import { gql } from "@apollo/client";

export const CONNECTORS = gql`
  query Connectors($category: String) {
    connectors(category: $category) {
      key
      category
      label
      vendor
      direction
      selection
      serviceFile
      inbound
      configKeys
      status
      configured
      enabled
      hasCredentials
      envConfigured
      presentConfigKeys
      missingConfigKeys
      integrationId
      config
    }
  }
`;

const connectors = { CONNECTORS };

export default connectors;
